import React from "react";

export const MobileFooter: React.FC = () => (
  <div className="w-full mx-auto">
    <div className="text-center max-w-250 mx-auto">
      <p className="text-caption">
        Xfinity Internet required. Taxes & fees extra.
      </p>
    </div>
  </div>
);

export const InternetFooter: React.FC = () => (
  <div className="w-full mx-auto">
    <div className="text-center max-w-250 mx-auto">
      <p className="text-caption">
        <strong>Xfinity Pro:</strong> Requires post-paid Xfinity internet and
        compatible gateway. Max. up to 2 WiFi extenders (if recommended).
        Battery Backup sold separately. <strong>Xfinity Smart Home:</strong>{" "}
        Requires an indoor camera ($60 value) billed at $2.50/mo for 24 mos. If
        Xfinity Smart Home canceled before 24 mos, you will be charged the
        remaining balance.
      </p>
    </div>
  </div>
);

export const EntertainmentFooter: React.FC = () => (
  <div className="w-full mx-auto">
    <div className="text-center max-w-250 mx-auto">
      <p className="text-caption">
        <strong>StreamSaver™:</strong> Restrictions apply. Xfinity Internet or
        TV req’d. Taxes extra. Pricing subj. to change. Peacock Premium with ads
        is currently a $10.99/mo value.
        <br />
        <strong>Now TV Latino:</strong> Peacock Premium with ads (currently
        $10.99/mo. value) and ViX Premium with ads (currently $6.99/mo. value)
        included with NOW TV Latino. Management of existing subscriptions may be
        required to avoid multiple active subscriptions and corresponding
        charges. Activation of an account for each service required.
      </p>
    </div>
  </div>
);

export const PrepaidFooter: React.FC = () => (
  <div className="w-full mx-auto">
    <div className="text-center max-w-250 mx-auto">
      <p className="text-caption">
        Restrictions apply. Payments must be made online only via credit, debit,
        or prepaid card. Autopay and paperless billing required. Pricing subject
        to change. <strong>NOW Mobile:</strong> Reduced speeds after 20GB of
        usage/line. In times of congestion, your data may be temporarily slower
        than other traffic. Must pay in full or bring your own device for NOW
        Mobile. Xfinity post-paid or NOW Internet required. Intl. and roaming
        charges extra. NOW is a trademark of Comcast.
      </p>
    </div>
  </div>
);
